import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/components/NotFound'

import globals from '@/globals'

import dashboardsRoutes from './dashboards'
import PostRoutes from './posts'
import ProfileRoutes from './profile'
import MessageRoutes from './message'
import HomeRoutes from './home'
import DoctorRoutes from './doctors'
import DepartmentRoutes from './departments'
import TimeTableRoutes from './timetables'
// Authentication Router
import authRouter from './auth'
// Vuex Store
import store from '@/store/store'

Vue.use(Router)
Vue.use(Meta)

const ROUTES = [
  // Default route
  { path: '', redirect: '/home' }
]
  .concat(HomeRoutes)
  .concat(dashboardsRoutes)
  .concat(PostRoutes)
  .concat(DoctorRoutes)
  .concat(DepartmentRoutes)
  .concat(TimeTableRoutes)
  .concat(authRouter)
  .concat(ProfileRoutes)
  .concat(MessageRoutes)

// 404 Not Found page
ROUTES.push({
  path: '*',
  component: NotFound
})

const router = new Router({
  base: '/',
  mode: 'history',
  routes: ROUTES
})

router.afterEach(() => {
  // Remove initial splash screen
  const splashScreen = document.querySelector('.app-splash-screen')
  if (splashScreen) {
    splashScreen.style.opacity = 0
    setTimeout(() => splashScreen && splashScreen.parentNode.removeChild(splashScreen), 300)
  }

  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Set loading state
  document.body.classList.add('app-loading')
  // check if the route requires authentication and user is not logged in
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.authenticated) {
    next({ name: 'Login' })
    return
  }
  // if logged in redirect to dashboard
  if (to.path === '/auth/login' && store.state.authenticated) {
    next({ path: '/dashboard' })
    return
  }
  next()

  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
